import React, { useState } from 'react';
import { MapPin, Clock, Users, Building } from 'lucide-react';

const TrustedCompanies = () => {
  const [activeTab, setActiveTab] = useState('coworking-spaces');

  const seoData = {
    'coworking-spaces': {
      title: 'Coworking Spaces Near Me - Bangalore Areas',
      content: [
        'Coworking spaces in Hebbal • Coworking spaces in Sahakara Nagar • Coworking spaces in Thanisandra • Coworking spaces in Jakkur • Coworking spaces in Kodigehalli • Coworking spaces in RT Nagar • Coworking spaces in Nagawara • Coworking spaces in Kempapura • Coworking spaces in Sanjay Nagar • Coworking spaces in Dollars Colony • Coworking spaces in HBR Layout • Coworking spaces in Amruthahalli • Coworking spaces in Bhoopasandra • Coworking spaces in Vidyaranyapura • Coworking spaces in Yelahanka',
        'Coworking spaces in Manyata Tech Park • Coworking spaces in Ganganagar • Coworking spaces in CBI Road • Coworking spaces in HMT Layout • Coworking spaces in Anand Nagar • Coworking spaces in Dinnur • Coworking spaces in Sadashiv Nagar • Coworking spaces in BEL Layout • Coworking spaces in New BEL Road • Coworking spaces in Tharalabalu • Coworking spaces in Mehkri Circle • Coworking spaces in Badrappa Layout • Coworking spaces in Bellary Road • Coworking spaces in Airport Road • Coworking spaces in Palace Road • Coworking spaces in Jalahalli Village • Coworking spaces in Jayamahal'
      ]
    },
    'day-pass': {
      title: 'Coworking Day Pass - Bangalore Areas',
      content: [
        'Coworking day pass in Hebbal • Coworking day pass in Sahakara Nagar • Coworking day pass in Thanisandra • Coworking day pass in Jakkur • Coworking day pass in Kodigehalli • Coworking day pass in RT Nagar • Coworking day pass in Nagawara • Coworking day pass in Kempapura • Coworking day pass in Sanjay Nagar • Coworking day pass in Dollars Colony • Coworking day pass in HBR Layout • Coworking day pass in Amruthahalli • Coworking day pass in Bhoopasandra • Coworking day pass in Vidyaranyapura • Coworking day pass in Yelahanka',
        'Coworking day pass in Manyata Tech Park • Coworking day pass in Ganganagar • Coworking day pass in CBI Road • Coworking day pass in HMT Layout • Coworking day pass in Anand Nagar • Coworking day pass in Dinnur • Coworking day pass in Sadashiv Nagar • Coworking day pass in BEL Layout • Coworking day pass in New BEL Road • Coworking day pass in Tharalabalu • Coworking day pass in Mehkri Circle • Coworking day pass in Badrappa Layout • Coworking day pass in Bellary Road • Coworking day pass in Airport Road • Coworking day pass in Palace Road • Coworking day pass in Jalahalli Village • Coworking day pass in Jayamahal'
      ]
    },
    'meeting-rooms': {
      title: 'Meeting Rooms Near Me - Bangalore Areas',
      content: [
        'Meeting rooms in Hebbal • Meeting rooms in Sahakara Nagar • Meeting rooms in Thanisandra • Meeting rooms in Jakkur • Meeting rooms in Kodigehalli • Meeting rooms in RT Nagar • Meeting rooms in Nagawara • Meeting rooms in Kempapura • Meeting rooms in Sanjay Nagar • Meeting rooms in Dollars Colony • Meeting rooms in HBR Layout • Meeting rooms in Amruthahalli • Meeting rooms in Bhoopasandra • Meeting rooms in Vidyaranyapura • Meeting rooms in Yelahanka',
        'Meeting rooms in Manyata Tech Park • Meeting rooms in Ganganagar • Meeting rooms in CBI Road • Meeting rooms in HMT Layout • Meeting rooms in Anand Nagar • Meeting rooms in Dinnur • Meeting rooms in Sadashiv Nagar • Meeting rooms in BEL Layout • Meeting rooms in New BEL Road • Meeting rooms in Tharalabalu • Meeting rooms in Mehkri Circle • Meeting rooms in Badrappa Layout • Meeting rooms in Bellary Road • Meeting rooms in Airport Road • Meeting rooms in Palace Road • Meeting rooms in Jalahalli Village • Meeting rooms in Jayamahal'
      ]
    },
    'office-space': {
      title: 'Private Office & Commercial Space - Bangalore Areas',
      content: [
        'Commercial office space in Hebbal • Commercial office space in Sahakara Nagar • Commercial office space in Thanisandra • Commercial office space in Jakkur • Commercial office space in Kodigehalli • Commercial office space in RT Nagar • Commercial office space in Nagawara • Commercial office space in Kempapura • Commercial office space in Sanjay Nagar • Commercial office space in Dollars Colony • Commercial office space in HBR Layout • Commercial office space in Amruthahalli • Commercial office space in Bhoopasandra • Commercial office space in Vidyaranyapura • Commercial office space in Yelahanka',
        'Commercial office space in Manyata Tech Park • Commercial office space in Ganganagar • Commercial office space in CBI Road • Commercial office space in HMT Layout • Commercial office space in Anand Nagar • Commercial office space in Dinnur • Commercial office space in Sadashiv Nagar • Commercial office space in BEL Layout • Commercial office space in New BEL Road • Commercial office space in Tharalabalu • Commercial office space in Mehkri Circle • Commercial office space in Badrappa Layout • Commercial office space in Bellary Road • Commercial office space in Airport Road • Commercial office space in Palace Road • Commercial office space in Jalahalli Village • Commercial office space in Jayamahal'
      ]
    }
  };

  const tabs = [
    { 
      id: 'coworking-spaces', 
      label: 'Coworking Spaces Near Me', 
      icon: MapPin 
    },
    { 
      id: 'day-pass', 
      label: 'Coworking Day Pass', 
      icon: Clock 
    },
    { 
      id: 'meeting-rooms', 
      label: 'Meeting Rooms Near Me', 
      icon: Users 
    },
    { 
      id: 'office-space', 
      label: 'Shared/Private Office Space', 
      icon: Building 
    }
  ];

  return (
    <div className="bg-white py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
            Premium Workspace Solutions Across North Bangalore
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Discover coworking spaces, meeting rooms, and office solutions in Hebbal, Manyata Tech Park, and surrounding areas
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap justify-center gap-2 mb-8 bg-gray-100 rounded-2xl p-2">
          {tabs.map((tab) => {
            const IconComponent = tab.icon;
            const isActive = activeTab === tab.id;
            
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-4 py-3 rounded-xl font-medium text-sm transition-all duration-300 ${
                  isActive
                    ? 'bg-[#e30613] text-white shadow-lg'
                    : 'text-gray-700 hover:text-[#e30613] hover:bg-white'
                }`}
              >
                <IconComponent size={16} />
                <span className="hidden sm:inline">{tab.label}</span>
                <span className="sm:hidden">
                  {tab.label.split(' ')[0]}
                </span>
              </button>
            );
          })}
        </div>

        {/* Tab Content */}
        <div className="bg-gray-50 rounded-2xl p-6 lg:p-8">
          <div className="mb-4">
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              {seoData[activeTab].title}
            </h3>
          </div>

          <div className="prose prose-gray max-w-none">
            {seoData[activeTab].content.map((paragraph, index) => (
              <p key={index} className="text-gray-700 leading-relaxed mb-4 text-sm lg:text-base">
                {paragraph}
              </p>
            ))}
          </div>

          {/* CTA Section */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div>
                <p className="font-semibold text-gray-900 mb-1">
                  Ready to book your workspace?
                </p>
                <p className="text-gray-600 text-sm">
                  Get instant access to premium facilities across India
                </p>
              </div>
              <div className="flex gap-3">
                <button className="bg-[#e30613] hover:bg-[#c1050f] text-white px-6 py-2 rounded-lg font-medium transition-colors">
                  Book Now
                </button>
                <button className="border border-[#e30613] text-[#e30613] hover:bg-[#e30613] hover:text-white px-6 py-2 rounded-lg font-medium transition-colors">
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* SEO Footer */}
        <div className="mt-8 text-center">
          <p className="text-gray-500 text-xs">
            We use 🍪{' '}
            <button className="text-[#e30613] hover:underline">
              Know more
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrustedCompanies;